const footerData = [
	{
		heading: "Company and team",
		items: [
			{ name: "Company and team", link: "https://wise.com/us/about/our-story" },
			{ name: "Press", link: "https://newsroom.wise.com/en-NAM/" },
			{ name: "Careers", link: "https://www.wise.jobs/" },
			{ name: "Service status", link: "https://status.wise.com/" },
			{ name: "Mission roadmap", link: "https://wise.com/mission-roadmap/" },
			{ name: "Affiliates and partnerships", link: "https://wise.com/us/partnerwise" },
			{ name: "Help centre", link: "https://wise.com/help/" },
		],
	},
	{
		heading: "Wise Products",
		items: [
			{ name: "International money transfer", link: "https://wise.com/us/send-money/" },
			{ name: "Wise account", link: "https://wise.com/us/multi-currency-account/" },
			{ name: "International debit card", link: "https://wise.com/us/card/" },
			{ name: "Travel money card", link: "https://wise.com/us/travel-money/travel-money-card" },
			{ name: "Large amount transfer", link: "https://wise.com/us/large-amounts/" },
			{ name: "Receive money", link: "https://wise.com/us/" },
			{ name: "Wise Platform", link: "https://platform.wise.com/" },
			{ name: "Business debit card", link: "https://wise.com/gb/business/card" },
			{ name: "Mass payments", link: "https://wise.com/us/business/batch-payments" },
		],
	},
	{
		heading: "Resources",
		items: [
			{ name: "News and blog", link: "https://wise.com/us/blog/" },
			{ name: "Currency converter", link: "https://wise.com/us/currency-converter/" },
			{ name: "Swift/BIC codes", link: "https://wise.com/us/swift-codes/" },
			{ name: "IBAN codes", link: "https://wise.com/us/iban/" },
			{ name: "Rate alerts", link: "https://wise.com/tools/exchange-rate-alerts/" },
			{ name: "Compare exchange rates", link: "https://wise.com/us/compare/" },
			{ name: "Invoice generator", link: "https://wise.com/us/invoice-generator/" },
			{ name: "Business Calculators", link: "https://wise.com/us/business-tools/" },
		],
	},
];

export default footerData;
